<div
  class="scroll-wrapper"
  [class.scroll-wrapper--top]="buttonPosition === 'top'"
  [class.scroll-wrapper--bottom]="buttonPosition === 'bottom'"
  #scrollWrapper
>
  <div class="scroll-container" #scrollContainer (scroll)="onScroll()">
    <ng-content></ng-content>
  </div>

  <!-- Solo se muestra si el contenido requiere scroll -->
  <div
    class="scroll-buttons"
    [class.scroll-buttons--side]="buttonPosition === 'side'"
    [class.scroll-buttons--top]="buttonPosition === 'top'"
    [class.scroll-buttons--bottom]="buttonPosition === 'bottom'"
    *ngIf="needsScroll"
  >
    <button
      class="scroll-btn"
      (click)="scrollUp()"
      [disabled]="!canScrollUp"
      aria-label="Scroll Up"
    >
      <svg
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
    </button>

    <button
      class="scroll-btn"
      (click)="scrollDown()"
      [disabled]="!canScrollDown"
      aria-label="Scroll Down"
    >
      <svg
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button>
  </div>
</div>
